import NdaListModal from './NdaListModal.component';

export default NdaListModal;
